"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = __importStar(require("@powerednow/complexData/entity"));
const date_1 = require("@powerednow/shared/modules/utilities/date");
let PurchaseSetupEntity = class PurchaseSetupEntity extends entity_1.default {
};
__decorate([
    (0, entity_1.field)({ type: 'int', primaryKey: true })
], PurchaseSetupEntity.prototype, "id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], PurchaseSetupEntity.prototype, "type", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', dbType: 'date', defaultValue: date_1.getNow })
], PurchaseSetupEntity.prototype, "dt_created", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], PurchaseSetupEntity.prototype, "product_name", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], PurchaseSetupEntity.prototype, "description_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], PurchaseSetupEntity.prototype, "period_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], PurchaseSetupEntity.prototype, "days_before_reminder", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], PurchaseSetupEntity.prototype, "days_before_expires", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', unique: true })
], PurchaseSetupEntity.prototype, "ios_product_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], PurchaseSetupEntity.prototype, "android_product_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', dbType: 'date' })
], PurchaseSetupEntity.prototype, "dt_valid_from", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', dbType: 'date', defaultValue: null })
], PurchaseSetupEntity.prototype, "dt_valid_to", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], PurchaseSetupEntity.prototype, "emails", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], PurchaseSetupEntity.prototype, "sms", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], PurchaseSetupEntity.prototype, "postcode", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], PurchaseSetupEntity.prototype, "users", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], PurchaseSetupEntity.prototype, "team_trial_enabled", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', minAppVersion: '6.8.0' })
], PurchaseSetupEntity.prototype, "team_enabled", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], PurchaseSetupEntity.prototype, "soldOnITC", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], PurchaseSetupEntity.prototype, "soldOnBT", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], PurchaseSetupEntity.prototype, "feature_prompt_ids", void 0);
__decorate([
    (0, entity_1.field)({ codeName: 'documentCreation', type: 'int' })
], PurchaseSetupEntity.prototype, "documentCreation", void 0);
__decorate([
    (0, entity_1.field)({ codeName: 'documentSend', type: 'int' })
], PurchaseSetupEntity.prototype, "documentSend", void 0);
__decorate([
    (0, entity_1.field)({ codeName: 'customerLimit', type: 'int' })
], PurchaseSetupEntity.prototype, "customerLimit", void 0);
__decorate([
    (0, entity_1.field)({ codeName: 'inviteConstructor', type: 'int' })
], PurchaseSetupEntity.prototype, "inviteConstructor", void 0);
__decorate([
    (0, entity_1.field)({ codeName: 'deviceSwitch', type: 'int' })
], PurchaseSetupEntity.prototype, "deviceSwitch", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], PurchaseSetupEntity.prototype, "min_app_version", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], PurchaseSetupEntity.prototype, "max_app_version", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], PurchaseSetupEntity.prototype, "suppliers", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], PurchaseSetupEntity.prototype, "cis", void 0);
__decorate([
    (0, entity_1.field)({ codeName: 'canApproveDoc', type: 'boolean' })
], PurchaseSetupEntity.prototype, "canApproveDoc", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], PurchaseSetupEntity.prototype, "products", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], PurchaseSetupEntity.prototype, "sites", void 0);
__decorate([
    (0, entity_1.field)({ minAppVersion: '7.5.0', type: 'boolean' })
], PurchaseSetupEntity.prototype, "form", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], PurchaseSetupEntity.prototype, "weight", void 0);
__decorate([
    (0, entity_1.field)({ minAppVersion: '7.7.3', type: 'boolean' })
], PurchaseSetupEntity.prototype, "tracking", void 0);
__decorate([
    (0, entity_1.field)({ minAppVersion: '7.8.0', type: 'boolean' })
], PurchaseSetupEntity.prototype, "tax_history", void 0);
__decorate([
    (0, entity_1.field)({ minAppVersion: '8.0.6', type: 'boolean' })
], PurchaseSetupEntity.prototype, "accounting_integration", void 0);
PurchaseSetupEntity = __decorate([
    entity_1.EntityDecorator
], PurchaseSetupEntity);
exports.default = PurchaseSetupEntity;
//# sourceMappingURL=../../../../src/models/purchaseSetup/entity.js.map